import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '@lib/components/Modal/Modal';
import Trans from '@lib/components/Trans/Trans';
import { IconName } from '@lib/components/Modal/enums';
import Typography from '@lib/components/Typography/Typography';
import ClipboardCopy, {
  ClipboardCopyType,
} from '@lib/components/ClipboardCopy/ClipboardCopy';
import styles from './HowToUseApiModal.module.scss';

const { VITE_PUBLIC_API_URL, VITE_PUBLIC_API_DOCS_URL } = import.meta.env;

export interface FormProps {
  isOpen: boolean;
  onClose: () => void;
}

const CODE_TEXT_1 = '{ "Authorization": "Bearer {{API_KEY}}" }';
const CODE_TEXT_2 = `curl -X POST -H "Authorization: Bearer {{API_TOKEN}}" -H "Content-Type: application/json" -d '{ "query": "{ hello }" }' ${VITE_PUBLIC_API_URL}`;

export default function HowToUseApiModal(props: FormProps) {
  const { isOpen, onClose } = props;
  const { t } = useTranslation();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={t('how-to-use-api-title')}
      description={<Trans i18nKey="how-to-use-api-text" />}
      icon={IconName.Help}
    >
      <div>
        <ul className={styles.list}>
          <li>
            <Typography variant="body" strong>
              {t('how-to-use-title-1')}
            </Typography>
            <Typography variant="body">
              <Trans
                i18nKey="how-to-use-text-1"
                values={{ url: VITE_PUBLIC_API_DOCS_URL }}
              />
            </Typography>
          </li>
          <li>
            <Typography variant="body" strong>
              {t('how-to-use-title-2')}
            </Typography>
            <Typography variant="body">{t('how-to-use-text-2')}</Typography>
            <ClipboardCopy
              copyText={CODE_TEXT_1}
              type={ClipboardCopyType.CodeBlock}
            >
              {CODE_TEXT_1}
            </ClipboardCopy>
          </li>
          <li>
            <Typography variant="body" strong>
              {t('how-to-use-title-3')}
            </Typography>
            <Typography variant="body">
              <Trans
                i18nKey="how-to-use-text-3"
                values={{ url: VITE_PUBLIC_API_URL }}
              />
            </Typography>
          </li>
          <li>
            <Typography variant="body" strong>
              {t('how-to-use-title-4')}
            </Typography>
            <Typography variant="body">{t('how-to-use-text-4')}</Typography>
            <ClipboardCopy
              copyText={CODE_TEXT_2}
              type={ClipboardCopyType.CodeBlock}
            >
              {CODE_TEXT_2}
            </ClipboardCopy>
          </li>
        </ul>
      </div>
    </Modal>
  );
}
